/**
 * Default deployment — narrative-neutral fallback.
 *
 * Used when the resolver cannot identify a specific deployment (e.g. the
 * Morrow verification flip via ?companion=morrow). Every string is
 * intentionally generic so a missed hardcode elsewhere in the app is
 * unmistakably visible during verification.
 */
const defaultDeployment = {
  id: "default",
  organizationLegalName: "SONMI Platform",
  organizationShortName: "SONMI",

  login: {
    productSummary:
      "the platform companion for operating rhythm and everyday shared context.",
    signInHeadingSuffix: "Sign in to",
  },

  tour: {
    personas: [],
  },

  home: {
    attentionEngineLabel: "attention",
    housekeepingCapExample:
      "A resource threshold was crossed; a signal was routed. Verify at your leisure.",
  },
};

export default defaultDeployment;
